export const generateCustomTransactionRows = (data, closeTransactions, dueDate, customColumns, percentageColumnValueCalc) => {
    // console.log(`generateCustomTransactionRows >> closeTransactions:`, closeTransactions);
    const customTransactionRows = [];

    data.forEach(driverDataRow => {
        // console.log(`GCT >>> driverDataRow:`, driverDataRow);
        customColumns?.forEach((column) => {
            const customTransactionRow = {};
            // console.log(`GCT >>> customColumns:`, customColumns);
            const fieldName = column.config.fieldName;
            // console.log(`GCT >>> customColumns > fieldName: ${fieldName}`);
            customTransactionRow.userId = driverDataRow.driverUserId;
            customTransactionRow.currency = "USD"; // default value
            customTransactionRow.cudbServiceId = "org-notaxi"; // default value
            customTransactionRow.customFieldName = fieldName;
            customTransactionRow.dueDate = dueDate;
            customTransactionRow.bookingDate = dueDate;
            customTransactionRow.closed = closeTransactions;

            // Calculate debit or credit based on column configuration
            let debit = 0;
            let credit = 0;
            if (column.config.type === "percentage") {
                let colConfig = column.config;
                const computedValue = percentageColumnValueCalc(driverDataRow, colConfig);
                // Adjust debit or credit based on coefficient
                debit = column.config.coefficient < 0 ? computedValue : 0;
                credit = column.config.coefficient >= 0 ? computedValue : 0;
            } else if (column.config.type === "number") {
                // Adjust debit or credit based on coefficient
                debit = column.config.coefficient < 0 ? driverDataRow[fieldName] : 0;
                credit = column.config.coefficient >= 0 ? driverDataRow[fieldName] : 0;
            }
            customTransactionRow.credit = credit;
            customTransactionRow.debit = debit;

            customTransactionRow.ui = { customColumns: customColumns, thisRowCustomColumnOrigValue: driverDataRow[fieldName] }

            customTransactionRows.push(customTransactionRow);
        });

        //if no custom column is defined we only add one custom transaction row with empty customFieldname and zero values
        if (!customColumns || customColumns.length < 1) {
            const customTransactionRow = {};
            customTransactionRow.userId = driverDataRow.driverUserId;
            customTransactionRow.currency = "USD"; // default value
            customTransactionRow.cudbServiceId = "org-notaxi"; // default value
            customTransactionRow.customFieldName = "";
            customTransactionRow.dueDate = dueDate;
            customTransactionRow.bookingDate = dueDate;
            customTransactionRow.closed = closeTransactions;
            customTransactionRow.credit = 0;
            customTransactionRow.debit = 0;
            customTransactionRow.ui = { customColumns: [], thisRowCustomColumnOrigValue: 0 }
            customTransactionRows.push(customTransactionRow);
        }
    });

    return customTransactionRows;
}

export const deleteTransactionRows = (bookingDate) => {
    const apiUrl = process.env.REACT_APP_RIDE_BACKOFFICE_SERVICE_URL + process.env.REACT_APP_RIDE_CUSTOM_TRANSACTION_BULK_ENDPOINTS;
    return fetch(apiUrl, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bookingDate: bookingDate }),
    });
}

export const loadTransactionRows = (bookingDate) => {
    const apiUrl = process.env.REACT_APP_RIDE_BACKOFFICE_SERVICE_URL + process.env.REACT_APP_RIDE_CUSTOM_TRANSACTION_LOAD_BULK_ENDPOINT;
    // console.log(`loadTransactionRows >> apiUrl: ${apiUrl}`);
    return fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bookingDate: bookingDate }),
    });
}

export const loadLastTransactionRow = () => {
    const apiUrl = process.env.REACT_APP_RIDE_BACKOFFICE_SERVICE_URL + process.env.REACT_APP_RIDE_CUSTOM_TRANSACTION_LOAD_LAST_ENDPOINT;
    // console.log(`loadLastTransactionRow >> apiUrl: ${apiUrl}`);
    return fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export const populateGridWithCustomTransactionRows = (originalData, customTransactionRows) => {
    // Iterate through each custom transaction row
    customTransactionRows.forEach((customTransactionRow) => {
        // Find the corresponding row in the original data
        const originalRow = originalData.find(row => row.driverUserId === customTransactionRow.userId);
        // If corresponding row is found, update it
        if (originalRow) {
            let fieldName = customTransactionRow.customFieldName;
            if (!fieldName) fieldName = "dummyField"
            originalRow[fieldName] = customTransactionRow?.ui?.thisRowCustomColumnOrigValue;
            originalRow[`${fieldName}_closed`] = customTransactionRow.closed;
        }
    });

    // After updating the original data, re-render the grid or update the state to reflect the changes
    // For example: 
    // setData([...originalData]);
}

const setAllCustomColumnRowsToSpecificValue = (data, col, value) => {
    data.forEach(
        row => {
            row[col.config.fieldName] = value;
            // console.log(`row['${col.config.fieldName}']: ${row[col.config.fieldName]}`);
        }
    )
}

export const checkIfIsDayDataOpen = (customTransactionRows) => {
    const hasclosed = customTransactionRows?.some(row => row.closed);
    // console.log(`++++++++++  IsOpen >>>>>>>> ${hasclosed!==true}`);
    return hasclosed !== true;
}

export const populateGridWithLastTransactionRow = (originalData, lastCustomTransactionRows) => {

    if (!originalData || !lastCustomTransactionRows || lastCustomTransactionRows.length < 1) return;
    lastCustomTransactionRows[0].ui.customColumns.forEach(col => {
        if (!col.config.uniformValues) {
            //For each custom column, if it is a *non-uniform* custom column, all cells will be filled with initial value from column's config
            const correspondTransactionRow = lastCustomTransactionRows.find(row => row.customFieldName === col.config.fieldName);
            const correspondValue = correspondTransactionRow?.ui?.thisRowCustomColumnOrigValue
            if (correspondValue) {
                // console.log(`correspondValue --> ${correspondValue}`);
                setAllCustomColumnRowsToSpecificValue(originalData, col, correspondValue);
            } else {
                setAllCustomColumnRowsToSpecificValue(originalData, col, col.config.initValue);
            }
        } else {
            //For each custom column, if it is a * uniform * custom column, all cells will be filled with the last saved record's value
            setAllCustomColumnRowsToSpecificValue(originalData, col, col.config.initValue);
        }
    })

    // After updating the original data, re-render the grid or update the state to reflect the changes
    // For example: 
    // setData([...originalData]);
}